async function parseResponseBody(response) {
    const text = await response.text();
    if (!text) return null;
    try {
        return JSON.parse(text);
    } catch {
        return { message: text };
    }
}

async function Fetch(link, method, data = null) {
    const isLogin = String(link).includes('/login');

    try {
        const response = await fetch(link, {
            method,
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                Accept: 'application/json',
            },
            body: data,
        });

        const status = response.status;
        const json = await parseResponseBody(response);

        if (status === 401 && !isLogin) {
            localStorage.removeItem('token');
            if (!window.location.pathname.includes('/login')) {
                window.location.assign('/login');
            }
        }

        return { status, data: json };
    } catch (err) {
        return {
            status: 0,
            data: {
                message: err?.message || 'Network error — تأكد أن الخادم يعمل على المنفذ 8000',
                errors: [err?.message || 'Network error'],
            },
        };
    }
}

export default Fetch;
